import React from 'react'
import { Alert, Box } from '@mui/material'

interface DraftIndicatorProps {
  dirty?: boolean
}

export const DraftIndicator: React.FC<DraftIndicatorProps> = ({ dirty = false }) => (
  <Box mt={3}>
    <Alert severity="info" aria-label={dirty ? 'Draft saved' : 'Draft restored'}>
      {dirty ? 'Draft saved.' : 'Draft restored.'}
    </Alert>
  </Box>
)
